import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Login from '@pages/auth/login/login-page';
import Register from '@pages/auth/register/register-page';
import RequestReceived from '@pages/auth/requestreceived/request-received-page';
import { Dashboard } from '@pages/dashboard/dashboard-page';
import ResetPassword from '@pages/auth/reset-password/reset-password-page';
import ForgotPassword from '@pages/auth/forgot-password/forgot-password-page';
import CrmAdminAccept from '@pages/auth/crm-admin-accept/crm-admin-accept-page';
import ConfirmPassword from '@pages/auth/confirm-password/confirm-password-page';
import Home from '@pages/home/home-page';
import ProtectedRoute from './ProtectedRoute';
import AffiliateUsage from '@pages/auth/affiliate-usage/affiliate-usage-page';
import { ProfilePage } from '@pages/profile/profile-page';
import { CoverPhotoPage } from '@pages/coverphoto/coverphoto-page';
import { PerformanceReportPage } from '@pages/performance-report/performance-report-page';
import { CommissionReportPage } from '@pages/commission-report/commission-report-page';
import { BankAccountInfo } from '@pages/bank-account-info/bank-account-info-page';
import CommissionProfiles from '@pages/commission-profiles/commission-profiles-page';
import AddEditCampaign from '@pages/campaign/add-campaign/add-edit-campaign-page';
import EditCampaign from '@pages/campaign/edit-campaign/edit-campaign-page';
import AddAffiliatePage from '@pages/add-affiliate/add-affiliate-page';
import AffiliateManagementPage from '@pages/affiliate-management/affiliate-management-page';
import ViewAffiliatePage from '@pages/view-affiliate/view-affiliate-page';
import TermsAndCondition from '../pages/terms-and-conditions/terms-and-conditions-page';
import CommissionSummaryPage from '@pages/commission-summary/commission-summary-page';
import AffiliateCommissionSummaryPage from '@pages/affiliate-commission-summary/affiliate-commission-summary-page';
import ViewSummaryPage from '@pages/view-summary/view-summary-page';
import CreateCommissionReportPage from '@pages/create-commision-report/create-commission-report-page';
import CreateCommissionReportAffiliatePage from '@pages/create-commision-report-affiliate/create-commision-report-affiliate-page';

const LoginRoutes = () => {
	return (
		<Switch>
			<Route path="/reset-password/:id" component={ResetPassword} />
			<Route path="/activate-account/:id" component={ConfirmPassword} />
			<Route path="/crmadminaccept/:id" component={CrmAdminAccept} />
			<Route path="/register/:companyId" component={Register} />
			<Route path="/terms-and-conditions" component={TermsAndCondition} />
			<Route path="/login" component={Login} />
			<Route path="/request-received" component={RequestReceived} />
			<Route path="/forgot-password" component={ForgotPassword} />
			<ProtectedRoute path="/" component={Home} />
		</Switch>
	);
};

const NoMatchPage = () => {
	return <h3>404 - Not found</h3>;
};

const HomeRoutes = () => {
	return (
		<Switch>
			<ProtectedRoute exact path="/affiliate-management/view-affiliate/:id/:affiliateId" component={ViewAffiliatePage} />
			<ProtectedRoute exact path="/commission-summary/view-summary/:affiliateId" component={ViewSummaryPage} />
			<ProtectedRoute exact path="/campaign/:type/:affId/:affiliateId" component={AddEditCampaign} />
			<ProtectedRoute exact path="/create-commission-report" component={CreateCommissionReportPage} />
			<ProtectedRoute exact path="/create-commision-report-affiliate" component={CreateCommissionReportAffiliatePage} />
			<ProtectedRoute exact path="/commission-summary" component={CommissionSummaryPage} />
			<ProtectedRoute exact path="/commission-management" component={AffiliateCommissionSummaryPage} />
			<ProtectedRoute exact path="/campaign/edit-campaign/:affId" component={EditCampaign} />
			<ProtectedRoute exact path="/profile" component={ProfilePage} />
			<ProtectedRoute exact path="/cover-photo" component={CoverPhotoPage} />
			<ProtectedRoute exact path="/affiliate-usage" component={AffiliateUsage} />
			<ProtectedRoute exact path="/performance-report" component={PerformanceReportPage} />
			<ProtectedRoute exact path="/commission-report" component={CommissionReportPage} />
			<ProtectedRoute exact path="/commission-profiles" component={CommissionProfiles} />
			<ProtectedRoute exact path="/bank-info" component={BankAccountInfo} />
			<ProtectedRoute exact path="/affiliate-management" component={AffiliateManagementPage} />
			<ProtectedRoute exact path="/add-affiliate" component={AddAffiliatePage} />
			<ProtectedRoute exact path="/dashboard" component={Dashboard} />
			<ProtectedRoute exact path="/" component={Dashboard} />
			<Route component={NoMatchPage} />
		</Switch>
	);
};

export { LoginRoutes, HomeRoutes };
